import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/Images/Vireya_Insurance.png";

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  

  const handleSubmit = () => {
    // e.preventDefault();
    // setIsLoading(true);
    // await new Promise((resolve) => setTimeout(resolve, 1500));
    //   navigate('/acevalidation');
    // setIsLoading(false);
    window.open(process.env.REACT_APP_Nowcerts_Url, "_self");
  };

  return (
    <div className="login-container">
      {/* Logo at top left */}
      <div className="login-logo-top">
        <img className="login-logo-top-left" src={logo} alt="Envela Insurance Logo" />
      </div>

      <div className="login-wrapper">
        {/* Main Login Card */}
        <div className="login-card">
          {/* Header */}
          <div className="login-card-header">
            <div className="login-header-content">
              <h2 className="login-title">Welcome Back</h2>
              <p className="login-subtitle">Sign in to access your secure insurance portal</p>
            </div>
          </div>

          {/* Login Content */}
          <div className="login-content">
            <div className="login-button-section">
              <button type="submit" disabled={isLoading} className="validation-continue-button" onClick={handleSubmit}>
                {isLoading ? (
                  <>
                    <svg className="login-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path
                        style={{ opacity: 0.75 }}
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <span>Signing in...</span>
                  </>
                ) : (
                  <>
                    <span>Continue with NowCerts</span>
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M5 12h14m-7-7l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}